import { useState, useCallback } from 'react'
import { QueryDocumentSnapshot } from 'firebase/firestore'
import FirestoreUser from '../types/FirestoreUser'
import { ReportInfo } from '../types/ReportTypes'
import { fetchUserReportsData } from '../utils/fetchUserReportsData'

/**
 * Fetches report metadata for an array of user documents.
 * This hook centralizes the logic for fetching report information
 * used by both CompletionPage and UsersPage.
 */
export function useFetchUserReportsData() {
  const [isLoading, setIsLoading] = useState(false)

  const fetchReportsData = useCallback(
    async (
      userDocs: QueryDocumentSnapshot<FirestoreUser>[]
    ): Promise<Record<string, ReportInfo>> => {
      if (userDocs.length === 0) {
        return {}
      }

      setIsLoading(true)
      try {
        const reports = await fetchUserReportsData(userDocs, {}, false)
        return reports
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { fetchReportsData, isLoading }
}
